import { useSelector, useDispatch } from "react-redux";
import Draggable from "react-draggable";
import {
  Paper,
  Typography,
  IconButton,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { ACCOUNT_INITIALIZE } from "../store/actions";
import axios from "axios";
import configData from "../config";
import { useRef } from "react";

const LinkedinScrapeProgressModal = () => {
  const dispatcher = useDispatch();
  const account = useSelector((state) => state.account);
  const { linkedin_scraping_modal, linkedin_scraping_content } = account;

  const timerRef = useRef(null);
  const intervalRef = useRef(null);
  const timerStartedRef = useRef(false);
  const statusInterval = useRef(null);

  if (!linkedin_scraping_modal) return null;

  async function handleScrapingProgressClose() {
    dispatcher({
        type: ACCOUNT_INITIALIZE,
        payload: {
          linkedin_scraping_modal: false,
          linkedin_scraping_content: null,
        },
      });
  }

  return (<>
    <Draggable handle="#draggable-header">
      <Paper
        elevation={4}
        sx={{
          position: "fixed",
          top: 20,
          right: 20,
          zIndex: 9999,
          width: 400,
          borderRadius: 2,
          cursor: "default",
        }}
      >
        <Box
          id="draggable-header"
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            px: 1,
            py: 1,
            cursor: "move",
            color: "#fff",
            borderTopLeftRadius: 8,
            borderTopRightRadius: 8,
          }}
        >
          <Typography variant="h4">
            JD Fetching From Portal - {"linkedin"}
          </Typography>

          {!(linkedin_scraping_content.includes("RUNNING") || linkedin_scraping_content.includes("VERIFICATION_REQUIRED") || linkedin_scraping_content.includes("QUEUE")) && 
            <IconButton
              size="small"
              onClick={() => handleScrapingProgressClose()}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          }
        </Box>

        <Box 
          sx={{
            p: 1,
            maxHeight: 200,
            overflowY: "auto",
          }}
        >
          <Typography
            variant="h5"
            sx={{
              color: (() => {
                if (!linkedin_scraping_content) return "text.primary";

                if (linkedin_scraping_content.includes("RUNNING")) return "info.main";       // blue
                if (linkedin_scraping_content.includes("SUCCESS")) return "green";   // green
                if (linkedin_scraping_content.includes("FAILED")) return "#ff4d4d";      // red
                if (linkedin_scraping_content.includes("VERIFICATION_REQUIRED")) return "warning.main"; // orange
                if (linkedin_scraping_content.includes("QUEUE")) return "secondary.main";
                if (linkedin_scraping_content.includes("CANCELLED")) return "#c7802f";

                return "text.primary";
              })(),
              fontWeight: 600,
              whiteSpace: "pre-wrap",
              wordBreak: "break-word",
            }}
          >
            {linkedin_scraping_content || "No Content"}
          </Typography>
        </Box>
      </Paper>
    </Draggable>
  </>);
};

export default LinkedinScrapeProgressModal;
